import { RuntimeVariables } from "@nts/std/types";

export class FilterVariableViewModel {
    value: RuntimeVariables;
    label: string;

    constructor(value: RuntimeVariables, label: string) {
        this.value = value;
        this.label = label;
    }
}
